var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnlockSemibold(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.75 15.8546C13.483 15.5579 14 14.8393 14 14C14 12.8954 13.1046 12 12 12C10.8954 12 10 12.8954 10 14C10 14.8393 10.517 15.5579 11.25 15.8546V17C11.25 17.4142 11.5858 17.75 12 17.75C12.4142 17.75 12.75 17.4142 12.75 17V15.8546ZM12.5 14C12.5 14.2761 12.2761 14.5 12 14.5C11.7239 14.5 11.5 14.2761 11.5 14C11.5 13.7239 11.7239 13.5 12 13.5C12.2761 13.5 12.5 13.7239 12.5 14Z",
    fill: "#6C5CE7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.1476 6.18694C14.7868 4.78504 13.5133 3.75 12 3.75C10.2051 3.75 8.74998 5.20507 8.74998 7V8H17C18.6569 8 20 9.34315 20 11V19C20 20.6569 18.6569 22 17 22H7C5.34315 22 4 20.6569 4 19V11C4 9.34315 5.34315 8 7 8H7.24998V7C7.24998 4.37665 9.37663 2.25 12 2.25C14.2143 2.25 16.073 3.76451 16.6003 5.81306C16.7035 6.2142 16.462 6.62308 16.0609 6.72633C15.6598 6.82957 15.2509 6.58808 15.1476 6.18694ZM7 9.5H17C17.8284 9.5 18.5 10.1716 18.5 11V19C18.5 19.8284 17.8284 20.5 17 20.5H7C6.17157 20.5 5.5 19.8284 5.5 19V11C5.5 10.1716 6.17157 9.5 7 9.5Z",
    fill: "#6C5CE7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnlockSemibold);
export default __webpack_public_path__ + "static/media/unlock-semibold.75d0c3a057d0bf8d1feed5252da0e74f.svg";
export { ForwardRef as ReactComponent };